import clientData from 'utils/client-data'

const country = clientData.locality.country || 'US'
const elmo = clientData.experimentation || {}
const isNativeIOS = clientData.isFromMobileApp && clientData.isFromIOS

const brandCardsByCountry =
  {
    US: [
      {
        url_key: 'brands/apple',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/topbrand-apple.jpg',
        condition: (_elmo) => _elmo.appleLynx,
      },
      {
        url_key: 'brands/itunes',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/topbrand-apple.jpg',
        condition: (_elmo) => !_elmo.appleLynx,
      },
      {
        url_key: 'brands/google-play',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/topbrand-google.jpg',
        condition: () => !isNativeIOS,
      },
      {
        url_key: 'brands/target',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/topbrand-target.jpg',
      },
      {
        url_key: 'brands/sony-playstation-network',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/topbrand-sony.jpg',
      },
      {
        url_key: 'brands/nintendo-egift-card',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/topbrand-nintendo.jpg',
      },
      {
        url_key: 'brands/uber',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/topbrand-uber.jpg',
      },
      {
        url_key: 'brands/domino-s-pizza',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/topbrand-dominos.jpg',
      },
      {
        url_key: 'brands/spotify',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/topbrand-spotify.jpg',
      },
      {
        url_key: 'brands/lowes',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/topbrand-lowes.jpg',
      },
      {
        url_key: 'brands/walmart',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/topbrand-walmart.jpg',
      },
      {
        url_key: 'brands/adidas',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/topbrand-adidas.jpg',
      },
      {
        url_key: 'brands/airbnb',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/topbrand-airbnb.jpg',
      },
    ],
    DE: [
      {
        url_key: 'marken/itunes-de',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/topbrand-apple.jpg',
      },
      {
        url_key: 'marken/google-play-gutscheincode',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/topbrand-google.jpg',
        condition: () => !isNativeIOS,
      },
      {
        url_key: 'marken/nintendo-eshop-cards',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/topbrand-nintendo.jpg',
      },
      {
        url_key: 'marken/spotify-digital',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/topbrand-spotify.jpg',
      },
      {
        url_key: 'marken/aboutyou',
        img_url: 'https://www.paypalobjects.com/ppdg/aboutyou_logo.png',
      },
      {
        url_key: 'marken/xbox-guthaben',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/xbox_logo.png',
      },
      {
        url_key: 'marken/netflix',
        img_url: 'https://www.paypalobjects.com/ppdg/netflix_logo.png',
      },
      {
        url_key: 'marken/telekom-guthabencode',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/telekom_logo.png',
      },
      {
        url_key: 'marken/vodafone-guthabencode',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/vodafone.png',
      },
    ],
    GB: [
      {
        url_key: 'brands/adidas',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/topbrand-adidas.jpg',
      },
      {
        url_key: 'brands/itunes-uk',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/topbrand-apple.jpg',
      },
      {
        url_key: 'brands/google-play',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/topbrand-google.jpg',
        condition: () => !isNativeIOS,
      },
      {
        url_key: 'brands/nintendo-eshop-cards',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/topbrand-nintendo.jpg',
      },
      {
        url_key: 'brands/spotify-uk-99',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/topbrand-spotify.jpg',
      },
      {
        url_key: 'brands/uber',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/topbrand-uber.jpg',
      },
      {
        url_key: 'brands/microsoft-uk-gift-card',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/micorsoft_logo.png',
      },
      {
        url_key: 'brands/vodafone',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/vodafone.png',
      },
    ],
    CA: [
      {
        url_key: 'gift-cards/itunes',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/topbrand-apple.jpg',
      },
      {
        url_key: 'gift-cards/google-play',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/topbrand-google.jpg',
        condition: () => !isNativeIOS,
      },
      {
        url_key: 'gift-cards/playstation-store',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/topbrand-sony.jpg',
      },
      {
        url_key: 'gift-cards/nintendo',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/topbrand-nintendo.jpg',
      },
      {
        url_key: 'gift-cards/spotify',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/topbrand-spotify.jpg',
      },
      {
        url_key: 'gift-cards/sephora',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/sephora_logo.png',
      },
      {
        url_key: 'gift-cards/groupon',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/groupon_logo.png',
      },
    ],
    AU: [
      {
        url_key: 'brands/ebay',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/ebay_logo.png',
      },
      {
        url_key: 'brands/myer',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/myer_logo.png',
      },
      {
        url_key: 'brands/woolworths',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/woolworths_logo.png',
      },
      {
        url_key: 'brands/jb-hi-fi',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/jb_logo.png',
      },
      {
        url_key: 'brands/rebel-sport',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/rebel_logo.png',
      },
      {
        url_key: 'brands/netflix',
        img_url: 'https://www.paypalobjects.com/ppdg/netflix_logo.png',
      },
      {
        url_key: 'brands/spotify',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/topbrand-spotify.jpg',
      },
      {
        url_key: 'brands/ubergift',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/topbrand-uber.jpg',
      },
    ],
    AT: [
      {
        url_key: 'digitale-gutscheine/itunes-codes',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/topbrand-apple.jpg',
      },
      {
        url_key: 'digitale-gutscheine/google-play-gutscheincode',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/topbrand-google.jpg',
        condition: () => !isNativeIOS,
      },
      {
        url_key: 'digitale-gutscheine/nintendo-eshop-cards',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/topbrand-nintendo.jpg',
      },
      {
        url_key: 'digitale-gutscheine/spotify-digital',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/topbrand-spotify.jpg',
      },
      {
        url_key: 'digitale-gutscheine/aboutyou',
        img_url: 'https://www.paypalobjects.com/ppdg/aboutyou_logo.png',
      },
      {
        url_key: 'digitale-gutscheine/xbox-guthaben',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/xbox_logo.png',
      },
      {
        url_key: 'digitale-gutscheine/netflix',
        img_url: 'https://www.paypalobjects.com/ppdg/netflix_logo.png',
      },
      {
        url_key: 'digitale-gutscheine/telekom-wertkarte',
        img_url:
          'https://www.paypalobjects.com/digitalassets/c/gifts/us/telekom_logo.png',
      },
    ],
  }[country] || []

export default {
  name: 'brands',
  cards: brandCardsByCountry.filter(
    ({ condition }) => !condition || condition(elmo),
  ),
}
